// Dependencias generales
import React from "react";
import { useEffect, useState } from 'react';
import ShareWithUser from './User/ShareWithUser'
import ShareWithInstaller from './Installer/ShareWithInstaller'
import ManageSharedInstallation from './ManageSharedInstallation'

// Initial config - Meteo
const ShareInstallation = (params) => {

  const [selectedSharingOption, setSelectedSharingOption] = useState("")

  useEffect(() => {    
    
    seleccionarOpcionSharing("verEstadoComparticion")

    console.log("Opciones de compartición de instalación cargadas correctamente.")    

  }, []);

  function seleccionarOpcionSharing(opcionSeleccionada){
    
    document.getElementById("botonAtras").className = document.getElementById("botonAtras").className.replaceAll(" hidden", "")    

    if(opcionSeleccionada === "compartirConUsuario"){      
      document.getElementById("iconoDetalleConfiguracion").innerHTML = "person"    
      document.getElementById("tituloDetalleConfiguracion").innerHTML = "Comparte esta instalación con otro usuario"
      setSelectedSharingOption(<ShareWithUser seleccionarOpcionSharing={seleccionarOpcionSharing}/>)
    }
    else if(opcionSeleccionada === "compartirConInstalador"){
      document.getElementById("iconoDetalleConfiguracion").innerHTML = "engineering"    
      document.getElementById("tituloDetalleConfiguracion").innerHTML = "Compartir con empresa"
      setSelectedSharingOption(<ShareWithInstaller seleccionarOpcionSharing={seleccionarOpcionSharing}/>)
    }
    else if(opcionSeleccionada === "verEstadoComparticion"){      
      document.getElementById("botonAtras").className += " hidden"
      document.getElementById("iconoDetalleConfiguracion").innerHTML = "share"        
      document.getElementById("tituloDetalleConfiguracion").innerHTML = "Compartición actual"
      params.seleccionarOpcion("Sharing")
      setSelectedSharingOption(<ManageSharedInstallation seleccionarOpcionSharing={seleccionarOpcionSharing}/>)      
    }  

  }

  return (          
    
    <main id="divMainContenedorStep">      

      <div id="divOpcionSeleccionada">

        <button id="botonAtras" className="link back hidden" onClick={() => seleccionarOpcionSharing("verEstadoComparticion")}><span className="material-icon">arrow_back</span>Volver</button>

        {selectedSharingOption}  

      </div>

    </main>
    
  )
}

export default ShareInstallation